import React from "react";

function CreateTicket() {
  const ticketLink = "/";
  const ticketCards = [
    {
      title: "Account Opening",
      items: [
        "Online Account Opening",
        "Offline Account Opening",
        "NRI Account Opening",
      ],
    },
    {
      title: "Trade Support",
      items: [
        "Intraday margins",
        "Fees and charges",
        "Order execution",
      ],
    },
    {
      title: "Platform Help",
      items: [
        "Kite user manual",
        "Segment activation",
        "App down issues",
      ],
    },
  ];

  return (
    <section className="container ticket-section">
      <div className="section-heading">
        <h1>To create a ticket, select a relevant topic</h1>
      </div>
      <div className="row ticket-grid">
        {ticketCards.map((card) => (
          <article key={card.title} className="ticket-card col-4">
            <h3>{card.title}</h3>
            <ul>
              {card.items.map((item) => (
                <li key={item}>
                  <a href={ticketLink}>{item}</a>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CreateTicket;
